import ImgLogoProject from "../assets/svg/project-card-logo.svg";
import {apiAddProjects, apiGetProject, apiUpdateProject} from "../api/projectApi";

export const projectFormData = {
    key: "project",
    title: "پروژه",
    addFunction: apiAddProjects,
    getFunction: apiGetProject,
    updateFunction: apiUpdateProject,
    navigation: {
        title: "افزودن پروژه",
        // description: "ثبت اطلاعات پروژه",
        backTitle: "بازگشت",
        backUrl: "/projects",
    },
    summaryInfo: {
        key: "project",
        primaryTitleKey: "title",
        addTempTitle: "افزودن پروژه جدید",
        saveTitle: "ذخیره پروژه ها",
        defaultImage: ImgLogoProject,
    },
    tabs: [
        {
            key: "project",
            name: "پروژه",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },
                    initialInputs: {
                        inputs: [
                            {
                                wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                                name: "title",
                                label: "عنوان پروژه",
                                required: true,
                                primary: true,
                                maxLength: 32,
                                style: {
                                    paddingRight: "60px",
                                    paddingLeft: "50px",
                                },
                            },
                        ],
                    },
                    status: {
                        active: true,
                        name: "active",
                        type: "status",
                        wrapperClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12",
                    },
                    radioInput: {
                        wrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12",
                        active: true,
                        type: "radioInput",
                        name: "default",
                        label: "پیش فرض",
                        options: [
                            {
                                title: "بله",
                                value: 1,
                            },
                            {
                                title: "خیر",
                                value: 0,
                            },
                        ],
                    },
                    inputs: [],
                },
            },
        },
    ],
};
